import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import Loader from './components/Loader';

// Lazy-load components
const Header = lazy(() => import('./Header'));
const Home = lazy(() => import('./components/Home'));
const Services = lazy(() => import('./components/Services'));
const Talent = lazy(() => import('./components/Talent'));
const Contact = lazy(() => import('./components/Contact'));
const About = lazy(() => import('./components/About'));
const Garnier = lazy(() => import('./case-studies/Garnier-uv-sunscreen'));
const JioHotstar = lazy(() => import('./case-studies/JioHotstar-live-telecast'));
const Netrikann = lazy(() => import('./case-studies/Netrikann-x-JioHotstar'));

function App() {
  return (
    <Router>
      {/* Suspense fallback to display while the component is loading */}
      <Suspense fallback={<Loader />}>
        <Header />
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/talent" element={<Talent />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/case-studies/Garnier-uv-sunscreen" element={<Garnier />} />
            <Route path="/case-studies/JioHotstar-live-telecast" element={<JioHotstar />} />
            <Route path="/case-studies/Netrikann-x-JioHotstar" element={<Netrikann />} />
          </Routes>
        </div>
      </Suspense>
    </Router>
  );
}

export default App;
